import React from 'react'

export default class About extends React.Component {
  render() {
    return (
      <div id="about" className="section clearfix">
        <div className="container-fluid" style={{ marginTop: '4.5%' }}>
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h1 className="title text-center">
                About <span>NicheSolv</span>
              </h1>
              <p className="lead text-center">
                We build it, and they will come!
              </p>
              <div className="row">
                <div className="col-md-5 col-lg-5">
                  <div className="space" />
                  <img className="img1" src="images/image11.png" />
                </div>
                <div className="col-md-7 col-lg-7">
                  <ul className="pdzero">
                    <p>NicheSolv is based in Bangalore, India</p>
                    <p />
                    <a
                      href="http://in.linkedin.com/in/natrajgujran"
                      target="_blank"
                    >
                      <b>Natraj Gujran</b>{' '}
                    </a>
                    <b>heads NicheSolv.</b>
                    <br />
                    Natraj has worked in technical leadership positions mostly
                    for companies in the San Francisco Bay area. The experience
                    spans large companies like Xerox Research to startups like
                    Sidestep.com(acquired by Kayak.com). He has a Masters in
                    Software Engineering from Carnegie Mellon University,
                    Pittsburgh and a Bachelors in Electronics Engineering from R
                    V College of Engineering, Bangalore. The Master’s degree is
                    jointly offered by the Software Engineering Institute (SEI),
                    and the School of Computer Science at Carnegie Mellon.
                    <br />
                    <br />
                  </ul>
                  <p />
                  <p />
                  <ul className="pdzero">
                    <a
                      href="https://in.linkedin.com/in/surendracr/"
                      target="_blank"
                    >
                      <b>Surendra Ramarao</b>{' '}
                    </a>
                    <b>Head of Software Development at NicheSolv.</b>
                    <br />
                    He has worked with Yokogawa, GE and HP in technical
                    leadership and managerial positions. Surendra has worked in
                    Industrial Automation, Healthcare and IT Infrastructure
                    domains in India and Singapore. He has extensive experience
                    in product architecture and design and has worked with a
                    variety of technologies including .NET, Java and Web
                    technologies.
                    <br />
                    <br />
                  </ul>
                  <p />
                  <p />
                  <ul className="pdzero">
                    <a
                      href="https://www.linkedin.com/in/ragoth-sundararajan-9b606712/"
                      target="_blank"
                    >
                      <b>Ragoth Sundararajan</b>{' '}
                    </a>
                    <b>Head, Data Science.</b>
                    <br />
                    Dr. Ragoth Sundararajan, heads Data Science efforts within
                    NicheSolv. He has worked on AI/ML applications focussed on
                    prediction of air pollution sensor data, model based systems
                    in the automotive sector, research in global climate &
                    hurricane risk modeling at MIT, USA. He was a co-founder of
                    a startup in hurricane risk modeling from 2005 -2010.
                    <br />
                    He has a PhD in Atmospheric Modeling from Uppsala
                    University, Sweden and a Masters in Aerospace Engineering
                    from IISc, Bangalore, India.
                  </ul>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/about.js